import React from 'react';
import { get } from 'lodash';
import { PauseTable, PauseTableContainer } from '../../../../components/PauseTable';
import { PauseTableHead, PauseTableHeadCell } from '../../../../components/PauseTable/components/PauseTableHead';
import { PauseTableTitle } from '../../../../components/PauseTable/components/PauseTableTitle';
import { PauseTableBody, PauseTableBodyCell } from '../../../../components/PauseTable/components/PauseTableRow';
import { PauseTypography } from '../../../../components/PauseTypography';
import { DownloadCloud } from '../../../../../assets/icons/feather/components';
import { PauseTextButton } from '../../../../components/PauseTextButton';

export enum InvoiceStatus {
  FreeTrial,
  TrialExtended,
  Pending,
  Paid,
  Cancelled,
}

const FreeTrialPill = () => (
  <PauseTypography
    dontWrapText
    css={(theme) => ({
      marginLeft: theme.spacing(1),
      background: get(theme, 'palette.pause.background.medium'),
      padding: theme.spacing(0.5),
      borderRadius: theme.spacing(0.5),
    })}
    component="span"
    variant="captionSmall"
    color="pause.primary.light"
  >
    <span role="img" aria-label="party">🎉</span>
    {' '}
    free trial
  </PauseTypography>
);

const PaidPill = () => (
  <PauseTypography
    dontWrapText
    css={(theme) => ({
      marginLeft: theme.spacing(1),
      background: get(theme, 'palette.pause.green.light'),
      padding: theme.spacing(0.5),
      borderRadius: theme.spacing(0.5),
    })}
    component="span"
    variant="captionSmall"
    color="pause.green.dark"
  >
    paid
  </PauseTypography>
);

const PendingPill = () => (
  <PauseTypography
    dontWrapText
    css={(theme) => ({
      marginLeft: theme.spacing(1),
      background: get(theme, 'palette.pause.yellow.light'),
      padding: theme.spacing(0.5),
      borderRadius: theme.spacing(0.5),
    })}
    component="span"
    variant="captionSmall"
    color="pause.yellow.dark"
  >
    {/* <span role="img" aria-label="time">🕘</span> */}
    {/* {' '} */}
    pending
  </PauseTypography>
);

const TrialExtendedPill = () => (
  <PauseTypography
    dontWrapText
    css={(theme) => ({
      marginLeft: theme.spacing(1),
      background: get(theme, 'palette.pause.background.medium'),
      padding: theme.spacing(0.5),
      borderRadius: theme.spacing(0.5),
    })}
    component="span"
    variant="captionSmall"
    color="pause.primary.light"
  >
    extended trial
  </PauseTypography>
);

export type InvoiceRow = {
  period: string,
  users: string | number,
  invoiceTotal: string | number,
  currency: string,
  status: InvoiceStatus,
  invoiceLink?: string,
  hostedInvoiceURL?: string,
  paymentIntent?: {
    clientSecret: string
  }
}

type InvoiceTableProps = {
  invoices: InvoiceRow[]
}

export const InvoiceTable = ({
  invoices = [],
}: InvoiceTableProps) => (
  <PauseTableContainer>
    <PauseTableTitle title="Invoices" />
    <PauseTable>
      <PauseTableHead>
        <PauseTableHeadCell width="25%">
          Invoice Period
        </PauseTableHeadCell>
        <PauseTableHeadCell width="20%">
          No. of users
        </PauseTableHeadCell>
        <PauseTableHeadCell width="25%">
          Invoice total
        </PauseTableHeadCell>
        <PauseTableHeadCell width="25%">
          &nbsp;
        </PauseTableHeadCell>
      </PauseTableHead>
      {
        invoices.length ? invoices.map((invoice) => (
          <PauseTableBody key={invoice.invoiceLink}>
            <PauseTableBodyCell width="25%">{invoice.period}</PauseTableBodyCell>
            <PauseTableBodyCell width="20%">{invoice.users}</PauseTableBodyCell>
            <PauseTableBodyCell width="25%">
              {typeof invoice.invoiceTotal === 'number'
                ? `${invoice.currency}${Intl.NumberFormat().format(invoice.invoiceTotal as number)}` : invoice.invoiceTotal}
              {invoice.status === InvoiceStatus.FreeTrial ? <FreeTrialPill /> : null}
              {invoice.status === InvoiceStatus.Paid ? <PaidPill /> : null}
              {invoice.status === InvoiceStatus.Pending ? <PendingPill /> : null}
              {invoice.status === InvoiceStatus.TrialExtended ? <TrialExtendedPill /> : null}
            </PauseTableBodyCell>
            <PauseTableBodyCell width="25%">
              {invoice.status === InvoiceStatus.Paid ? (
                // @ts-ignore
                <PauseTextButton
                  inline
                  compact
                >
                  <a rel="noreferrer" target="_blank" href={invoice?.invoiceLink || ''}>
                    <DownloadCloud />
                    {' '}
                    Download invoice
                  </a>
                </PauseTextButton>
              ) : null}
              {invoice.status === InvoiceStatus.Pending && invoice?.hostedInvoiceURL ? (
                // @ts-ignore
                <PauseTextButton
                  inline
                  compact
                >
                  <a rel="noreferrer" href={invoice?.hostedInvoiceURL || ''}>
                    {/* <DownloadCloud /> TODO @chandru proper payment icon here */}
                    {' '}
                    Pay invoice
                  </a>
                </PauseTextButton>
              ) : null}
            </PauseTableBodyCell>
          </PauseTableBody>
        )) : (
          <PauseTableBody>
            <PauseTableBodyCell colspan={4}>
              No invoices yet.
            </PauseTableBodyCell>
          </PauseTableBody>
        )
      }
    </PauseTable>
  </PauseTableContainer>
);
